import styled, { css } from 'styled-components/macro';
import { defaultContainer } from '../../../styles/utils';
import {
  TransactionFilterDiv,
  transactionFilter
} from '../../../components/TableFilterStyles';
import { SearchStaticDiv } from '../../../components/SearchStaticStyles';

// export const PageHeaderDiv = styled.div`
//   margin-top: 20px;
//   @media screen and (min-width: 768px) {
//     margin-top: 25px;
//   }
// `;

// export const PageHeaderP = styled.p`
//   :last-of-type {
//     margin-bottom: 50px;
//     @media screen and (min-width: 768px) {
//       margin-bottom: 30px;
//     }
//     @media screen and (min-width: 1024px) {
//       margin-bottom: 45px;
//     }
//     @media screen and (min-width: 1440px) {
//       margin-bottom: 55px;
//     }
//   }
//   :not(:first-of-type) {
//     margin-top: 20px;
//   }
//   span {
//     font-weight: 600;
//   }
//   ${props =>
//     props.mobileCenter &&
//     css`
//     @media screen and (max-width: 767px) {
//       max-width: 425px
//       margin: 25px auto;
//     }
//   `}
// `;

// export const Subheaderh4 = styled.h4`
//   margin-bottom: 12px;
// `;

export const MerchantTransactionFiltersDiv = styled.div`
  ${defaultContainer};
  margin-bottom: 10px;
  @media screen and (max-width: 767px) {
    padding: 0;
  }
`;

export const FiltersBackgroundDiv = styled.div`
  @media screen and (max-width: 767px) {
    background-color: ${props => props.theme.concrete};
    padding: 3rem 0rem;
    ${props => props.theme.tabletHeaderShadow};
    margin-bottom: 35px;
  }
  @media screen and (min-width: 768px) {
    margin-bottom: 10px;
  }
`;

export const SearchFilterDiv = styled(TransactionFilterDiv)`
  ${SearchStaticDiv} {
    width: 100%;
  }
  input {
    padding-bottom: 0;
  }
  svg {
    top: 2px;
  }
  && {
    max-width: unset;
  }
  &:focus-within {
    border-bottom: 1px solid ${props => props.theme.blue};
  }
  ${props =>
    !props.rightEnd &&
    css`
      ${transactionFilter} {
        border-left: none;
      }
    `}
`;
